import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { printLetterByLetter, printingChars, titleInterval } from '../functions';
import Modal from '../components/Modal';
import { Link } from 'react-router-dom';
import { ProjectCard } from '../components/ProjectCard';

const title = 'Some of my projects';

const projects = [
	{
		title: 'magnet2torrent',
		description: 'A lightweight Node.js command-line tool that efficiently converts Magnet links to Torrent files. It offers a convenient solution for users to transform Magnet links, facilitating easier access and management of desired content.',
		image: 'magnet2torrent.png',
		date: '2021',
		technologies: ['Node.js', 'JavaScript'],
		code: 'https://github.com/nadhirxz/magnet2torrent',
		npm: 'https://www.npmjs.com/package/m2t',
	},
	{
		title: 'Meta-Z Website',
		description: 'Meta-Z is a P2E multiplayer game built on the unity engine. With its web-based marketplace and web3 functionality, users can securely connect their online wallets to explore a wide range of features. Purchase in-game items, trade NFTs, and immerse in the interactive MetaVerse Z.',
		image: 'meta-z-website.png',
		date: '2022',
		technologies: ['Next.js', 'Typescript', 'Tailwind CSS', 'Ethers.js', 'MetaMask'],
		demo: 'https://meta-z-demo.vercel.app',
	},
	{
		title: 'Meta-Z Smart Contracts',
		description: 'A collection of smart contracts associated with the MetaVerseZ project. These contracts are implemented using blockchain technology and serve various purposes within the MetaVerseZ ecosystem.',
		image: 'meta-z-contracts.png',
		date: '2022',
		technologies: ['Solidity', 'Ethereum', 'Hardhat', 'Ethers.js', 'Chai', 'Mocha', 'OpenZeppelin', 'IPFS'],
		code: 'https://github.com/MetaVerseZ/smart-contracts',
	},
	{
		title: 'TRK',
		description: 'This project involves the creation of a Fleet Management System for transportation companies. The system includes an interactive map with real-time vehicle tracking, user-friendly data management, and live video streaming. It was a hackathon submission for Junction X Algiers 2023.',
		image: 'trk.png',
		date: 'Oct 2023',
		technologies: ['Node.js', 'Typescript', 'Express.js', 'MQTT', 'WebSockets', 'Prisma', 'SQLite', 'React', 'Tailwind CSS', 'Leaflet', 'JWT'],
		code: 'https://github.com/L-Garage/JunctionXAlgiers2023',
		demo: 'https://www.youtube.com/watch?v=eSDSl2rSK74',
	},
	{
		title: 'Priefcase',
		description: 'A blockchain solution to go paperless and store your documents securely. With Priefcase, you can upload your documents to the blockchain and access them anytime, anywhere. It offers a convenient way to manage your documents, eliminating the need for physical copies and reducing the risk of losing them. It was a hackathon submission for DevFest Algiers 2022.',
		image: 'priefcase.png',
		date: 'Dec 2022',
		technologies: ['React', 'Typescript', 'Tailwind CSS', 'Ethers.js', 'Solidity', 'MetaMask'],
		demo: 'https://devpost.com/software/ddd-y321ex',
	},
	{
		title: 'Sahla Server',
		description: 'A scalable server using Node.js, Socket.IO, and Redis for efficient data storage. This server enables real-time communication between drivers and clients, improving coordination and task synchronization. With robust loggers, it tracks and analyzes server activities, creating a collaborative environment with reliable and scalable communication capabilities.',
		image: 'sahla-server.png',
		date: '2022',
		technologies: ['Node.js', 'JavaScript', 'Socket.IO', 'Express.js', 'Redis', 'PostgreSQL', 'MongoDB', 'JWT'],
	},
	{
		title: 'Sahla Driver Website',
		description: 'A web application for drivers to register and upload their documents. I created this while I was working at Sahla Solution as a full-stack developer.',
		image: 'sahla-driver-website.png',
		date: 'Jul 2022',
		technologies: ['React', 'JavaScript', 'Material UI'],
	},
	{
		title: 'Inventory Management App',
		description: 'A desktop application for managing inventory and serving as a Point of Sale (POS) system, providing businesses with an efficient solution.',
		image: 'inventory-manager.png',
		date: 'Oct 2021',
		technologies: ['Electron', 'React', 'Typescript', 'Tailwind CSS', 'JWT'],
	},
	{
		title: 'safe',
		description: 'A command-line tool that enables users to encrypt text and files securely using AES. It offers a streamlined and efficient way to protect sensitive information.',
		image: 'safe.png',
		date: 'Nov 2021',
		technologies: ['Node.js', 'JavaScript'],
		code: 'https://github.com/nadhirxz/safe',
	},
	{
		title: 'file-upload',
		description: 'A command-line tool in Node.js that simplifies the process of uploading files',
		image: 'file-upload.jpg',
		date: 'Nov 2021',
		technologies: ['Node.js', 'JavaScript'],
		code: 'https://github.com/nadhirxz/file-upload',
	},
	{
		title: 'Sudoku',
		description: 'A web-based project that brings the classic game of Sudoku to your browser. Enjoy interactive Sudoku gameplay with a user-friendly interface and responsive design.',
		image: 'sudoku.jpg',
		date: 'Dec 2020',
		technologies: ['React', 'HTML', 'CSS', 'JavaScript'],
		code: 'https://github.com/nadhirxz/sudoku-web',
		demo: 'https://nadhir.tech/sudoku-web/',
	},
	{
		title: 'ur-crypter',
		description: 'A client-side project built using HTML, CSS, and JavaScript. It offers a user-friendly interface for encrypting and decrypting data securely, with the implementation of encryption methods in vanilla JavaScript.',
		image: 'ur-crypter.jpg',
		date: 'Jul 2019',
		technologies: ['HTML', 'CSS', 'JavaScript', 'Bootstrap'],
		code: 'https://github.com/nadhirxz/ur-crypter',
		demo: 'https://nadhir.tech/ur-crypter',
	},
	{
		title: 'Speed Food',
		description: 'My first ever real project. This website is intended for use in ordering fast food from the club of a university residence. The entire site is developed in HTML, Bootstrap, jQuery and backed up by a PHP server with a MySQL database.',
		image: 'speedfood.png',
		date: 'Dec 2017',
		technologies: ['HTML', 'CSS', 'JavaScript', 'Bootstrap', 'PHP', 'MySQL', 'jQuery'],
	},
];

const defaultModal = { image: '', imageAlt: '', show: false };

const Projects = props => {
	const [modal, setModal] = useState(defaultModal);

	useEffect(() => {
		printLetterByLetter(document.getElementById('title'), title, titleInterval);
		printingChars();
	}, []);

	return (
		<>
			<motion.div initial="initial" animate="in" exit="out" variants={props.pageVariants} transition={props.pageTransition}>
				<h1 id="title"></h1>
				{projects.map((project, index) => (
					<ProjectCard key={index} project={project} setModal={setModal} />
				))}

				<Link to="/">
					<button className="btn back-btn" style={{ marginBottom: 25, marginTop: 10 }}>
						Back
					</button>
				</Link>
			</motion.div>
			<Modal show={modal.show} image={modal.image} imageAlt={modal.imageAlt} onClose={() => setModal(defaultModal)} />
		</>
	);
};

export default Projects;
